import { render, staticRenderFns } from "./CourseScheduleManager.vue?vue&type=template&id=5a6448de&scoped=true&"
import script from "./CourseScheduleManager.vue?vue&type=script&lang=js&"
export * from "./CourseScheduleManager.vue?vue&type=script&lang=js&"
import style0 from "./CourseScheduleManager.vue?vue&type=style&index=0&id=5a6448de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6448de",
  null
  
)

export default component.exports